import filter from 'lodash/filter';
import React from 'react';
import { useSelector } from 'react-redux';

import ImitateEditor from 'src/presentation/components/pages/imitate/ImitateEditor';
import TablePage, { TablePageRender } from 'src/presentation/components/pages/shared/TablePage';
import organizationsResource from 'src/actions/imitate/organizationsResource';
import { CompleteLoading } from 'src/presentation/components/CompleteLoadingTransition';
import { Edit } from 'src/presentation/components/pages/shared/rowActions/Edit';
import { RootState } from 'src/actions/configuration/rootReducer';
import { useResourceValues, isLoadingStatus } from 'src/presentation/hooks/useResource';

const dataAidPrefix = 'admin-imitate-';
const columnConfig = [
  { attr: 'name', label: 'Organization' },
  { attr: 'id', label: 'ID' },
];

const Imitate: TablePageRender = ({ root }) => {
  const initialized = useSelector((state: RootState) => state.initialized);
  const description = (
    <>
      <span>Pick an organization that you want to impersonate a user for.</span>
      <div>
        <a href="/sidekick/admin">Go to Sidekick V2 Admin</a>
      </div>
    </>
  );
  const { errors, loadingState, values } = useResourceValues(organizationsResource);

  if (!initialized.temporary) {
    return null;
  }
  return (
    <>
      <CompleteLoading />
      <TablePage
        columnConfig={columnConfig}
        editor={ImitateEditor}
        errors={errors}
        filterFunc={filterFunc}
        isLoading={isLoadingStatus(loadingState)}
        items={values}
        name="Imitate"
        description={description}
        resetErrors={organizationsResource.actions.resetErrors}
        root={root}
        renderRowActions={renderRowActions}
        data-aid={`${dataAidPrefix}page`}
      />
    </>
  );
};

function filterFunc(items, searchString) {
  if (!searchString) {
    return items;
  }
  const results = filter(items, item => {
    return item.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1 || item.id.indexOf(searchString) > -1;
  });
  return results;
}

function renderRowActions({ item }) {
  return (
    <>
      <Edit id={item.id} />
    </>
  );
}

export default Imitate;
